<template>
  <div class="">
    <div class="row justify-content-center py-5 einblenden1">
      <div class="col-lg-10 grauHintergrund">
        <!-- Versandverpackungen-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildVerpackungen/Versandverpackungen.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                <h2 class="kachelHeader">Versandverpackungen</h2>
                Unsere Versandkartons aus hochwertiger Wellpappe sind die perfekte Lösung
                für den sicheren und zuverlässigen Versand Ihrer Produkte. Sie bestehen je
                nach Ausführung aus ein- oder zweiwelliger Pappe und bieten damit
                optimalen Schutz für leichte bis mittelschwere Waren. Durch ihre stabile
                Konstruktion sind sie vielseitig einsetzbar – ob im E-Commerce, im Lager,
                für Umzüge oder im täglichen Versandgeschäft. Die Kartons lassen sich
                schnell aufrichten, werden platzsparend flach angeliefert und sind
                vollständig recyclingfähig.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  Innenmaße:
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="vplaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="vpbreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Höhe in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="vphoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="vpText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText" id="basic-addon1">Anzahl</span>
              <input
                type="number"
                class="form-control anzahlFeld"
                v-model="verpackungen"
              />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addItemVP()"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedVp" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>

        <!-- Industrieverpackungen-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildVerpackungen/Industrieverpackungen.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">Industrieverpackungen</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Unsere Industrieverpackungen bieten zuverlässigen Schutz für Produkte
                jeder Art – von empfindlichen Kleinteilen bis zu schweren oder sperrigen
                Industriekomponenten. Ob aus Wellpappe, Holz, Kunststoff oder Schaumstoff
                – jede Verpackung ist robust, funktional und auf höchste Anforderungen im
                Transport und in der Lagerung ausgelegt. Wir liefern sowohl
                Standardlösungen als auch individuell entwickelte Verpackungskonzepte, die
                auf Ihre Prozesse abgestimmt sind. Dabei achten wir auf Qualität,
                Nachhaltigkeit und maximale Effizienz.
              </div>
              <div class="col-lg-4">
                <span class="input-group-text" style="width: 100%" id="basic-addon1"
                  >Kurze Beschreibung</span
                >
                <div class="input-group mb-3">
                  <textarea
                    class="form-control"
                    aria-label="With textarea"
                    v-model="ipText"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="ip" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addIp()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedIp" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>

        <!-- ESD-Verpackungen-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildVerpackungen/Esd.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">ESD-Verpackungen</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Unsere ESD-Verpackungen bieten zuverlässigen Schutz für empfindliche
                elektronische Bauteile und Geräte vor elektrostatischer Entladung. Sie
                sind speziell dafür entwickelt, Spannungen abzuleiten oder zu blockieren
                und so Schäden an sensibler Elektronik wirksam zu verhindern. Ob
                leitfähig, ableitfähig oder abschirmend – wir bieten eine breite Auswahl
                an Verpackungslösungen, die den gängigen ESD-Normen entsprechen und sich
                nahtlos in bestehende Fertigungs- oder Versandprozesse integrieren lassen.
                Ideal für Lagerung, Transport und Produktion in der Elektronikindustrie.
              </div>
              <div class="col-lg-4">
                <span class="input-group-text" style="width: 100%" id="basic-addon1"
                  >Kurze Beschreibung</span
                >
                <div class="input-group mb-3">
                  <textarea
                    class="form-control"
                    aria-label="With textarea"
                    v-model="espText"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="esp" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addEsp()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedEs" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>
        <!-- Präsentverpackungen-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildVerpackungen/Geschenk.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">Präsentverpackungen</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Unsere Präsentverpackungen vereinen Stil und Funktion und setzen jedes
                Geschenk perfekt in Szene – ob für private Anlässe, Firmenpräsente oder
                besondere Events. Von edlen Geschenkkartons über dekorative Schachteln bis
                hin zu individuell gestaltbaren Verpackungen bieten wir vielfältige
                Lösungen für jeden Geschmack und Anlass. Hochwertige Materialien,
                sorgfältige Verarbeitung und ein ansprechendes Design machen jede
                Verpackung zu etwas Besonderem und sorgen für einen bleibenden Eindruck
                beim Beschenkten.
              </div>
              <div class="col-lg-4">
                <span class="input-group-text" style="width: 100%" id="basic-addon1"
                  >Kurze Beschreibung</span
                >
                <div class="input-group mb-3">
                  <textarea
                    class="form-control"
                    aria-label="With textarea"
                    v-model="pvText"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="pv" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addPv()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedPv" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>
        <!-- Pharmazie-Verpackungen-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildVerpackungen/Pharmazie.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">Pharmazie-Verpackungen</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Unsere Pharmazie-Verpackungen erfüllen höchste Anforderungen an
                Sicherheit, Hygiene und Funktionalität. Sie sind speziell für den Schutz
                sensibler pharmazeutischer Produkte entwickelt und gewährleisten eine
                sichere Lagerung und einen zuverlässigen Transport – vom Labor bis zur
                Apotheke. Ob für Tabletten, Flüssigkeiten, Proben oder Medizinprodukte:
                Unsere Verpackungslösungen bieten optimale Barriereeigenschaften, klare
                Kennzeichnungsmöglichkeiten und entsprechen allen relevanten gesetzlichen
                Vorgaben. Qualität und Reinheit stehen dabei stets im Fokus.
              </div>
              <div class="col-lg-4">
                <span class="input-group-text" style="width: 100%" id="basic-addon1"
                  >Kurze Beschreibung</span
                >
                <div class="input-group mb-3">
                  <textarea
                    class="form-control"
                    aria-label="With textarea"
                    v-model="phText"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="ph" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addPh()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedPh" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { anfragenStore } from "@/stores/AnfrageStore";
export default {
  name: "balkenMitBildPaletten",
  data() {
    return {
      vplaenge: 0,
      vpbreite: 0,
      vphoehe: 0,
      vpText: "",
      verpackungen: 0,
      ipText: "",
      ip: 0,
      espText: "",
      esp: 0,
      pvText: "",
      pv: 0,
      phText: "",
      ph: 0,

      addedVp: false,
      addedIp: false,
      addedEs: false,
      addedPv: false,
      addedPh: false,
    };
  },

  methods: {
    addItemVP() {
      let item = {
        name: "Verpackungen",
        anzahl: this.verpackungen,
        beschreibung: this.vpText,
        masse: {
          laenge: this.vplaenge,
          breite: this.vpbreite,
          hoehe: this.vphoehe,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedVp = true;
      setTimeout(() => {
        this.addedVp = false;
        this.verpackungen = 0;
        this.vplaenge = 0;
        this.vpbreite = 0;
        this.vphoehe = 0;
        this.vpText = "";
      }, 2000);
    },
    addIp() {
      let item = {
        name: "Industrieverpackung",
        anzahl: this.ip,
        beschreibung: this.ipText,
      };
      const store = anfragenStore();

      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedIp = true;
      setTimeout(() => {
        this.addedIp = false;
        this.ip = 0;
        this.ipText = "";
      }, 2000);
    },
    addEsp() {
      let item = {
        name: "ESDVerpackung",
        anzahl: this.esp,
        beschreibung: this.espText,
      };
      const store = anfragenStore();

      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedEs = true;
      setTimeout(() => {
        this.addedEs = false;
        this.esp = 0;
        this.espText = "";
      }, 2000);
    },
    addPv() {
      let item = {
        name: "Präsentverpackung",
        anzahl: this.pv,
        beschreibung: this.pvText,
      };
      const store = anfragenStore();

      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedPv = true;
      setTimeout(() => {
        this.addedPv = false;
        this.pv = 0;
        this.pvText = "";
      }, 2000);
    },
    addPh() {
      let item = {
        name: "Pharmazie-Verpackung",
        anzahl: this.ph,
        beschreibung: this.phText,
      };
      const store = anfragenStore();

      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedPh = true;
      setTimeout(() => {
        this.addedPh = false;
        this.ph = 0;
        this.phText = "";

      }, 2000);
    },
  },
};
</script>
